/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/plugins/jquery/aaBusy.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/plugins/jquery.aaBusy.js
**/

/*------------------------------------*\
	aaBusy
\*------------------------------------*/
(function($) {
    $.fn.aaBusy = function (options) {
        var self = {},
            defaults = {
                message: "",
                showlogo: true,
                position: undefined,
                form: ""
            };
        self.settings = $.extend({}, defaults, options);
        self.source = this;
        self.start = function() {
            var message,
                $this = $(self.source).filter(':first'),
                $module = $this.find('> .aa-busy-module'),
                $form = $(self.settings.form),
                condition = ($this.length > 0 && $module.length === 0),
                $obj;
                if ($device.mobileApp){
                    $obj = $('<div class="aa-busy-module"><div class="aa-busy-bg"></div><div class="aa-busy-img"><div><img alt="American Airlines" src="/content/images/chrome/rebrand/icon_aa_spinner.png"></div><p><span class="aa-busy-text"></span></p><span class="aa-busy-spinner-app" aria-hidden="true"></span></div></div>');
                }else{
                    $obj = $('<div class="aa-busy-module"><div class="aa-busy-bg"></div><div class="aa-busy-img"><div><img alt="American Airlines" class="aa-busy-logo" src="/content/images/chrome/rebrand/aa-flight-icon.png"></div><p><span class="aa-busy-text"></span></p><span class="aa-busy-spinner" aria-hidden="true"></span></div></div>');
                }
            if (condition) {
                $this.addClass('aa-busy');
                $this.addClass('is-busy');
                //set message
                message = $this.attr('data-busy-message') || self.settings.message;
                if (message !== '') {
                    $obj.find('.aa-busy-text').text(message);
                } else {
                    $obj.find('.aa-busy-text').remove();
                }
                //set logo
                if (!self.settings.showlogo) {
                    $obj.find('.aa-busy-logo').remove();
                }
                //add module
                $this.append($obj);
                //set position
                var a = $this.find('.aa-busy-module').outerHeight(),
                    b = $this.find('.aa-busy-img').outerHeight(),
                    calc = ((a-b)/(2*a))*100,
                    pos = $this.data('busy-position') || self.settings.position || calc+'%';
                $this.find('.aa-busy-img').css('top',pos);
                $this.find('.aa-busy-text').attr('tabindex',-1).focus();
                //delay form submit: helps preloading images and on safari
                if ($form.length > 0) {
                    setTimeout( function() {
                        $form.submit();
                    },500);
                    $(window).on('unload', function() {}); //disables bfcache for safari
                }
            }
            return condition;
        };
        self.stop = function() {
            var $this = $(self.source).filter(':first'),
                $module = $this.find('> .aa-busy-module'),
                condition = ($this.length > 0 && $module.length > 0);
            if (condition) {
                $module.animate({opacity: 'hide'}, 500, function() {
                    $module.remove();
                    $this.removeClass('aa-busy');
                    $this.removeClass('is-busy');
                    if ($('*:focus').length === 0 && $this.hasClass('ui-dialog')) {
                        $this.find('h2').focus();
                    }
                });
            }
            return condition;
        };
        return self;
    };
})(jQuery);

/*------------------------------------*\
	aaBusyPromo
\*------------------------------------*/
(function($) {
    $.fn.aaBusyPromo = function (options, fragmentJsp) {
         var buildHtmlWithAdContent = '<div class="aa-busy-module"><div class="aa-busy-bg"></div><div class="aa-busy-img"><div><img alt="American Airlines" class="aa-busy-logo" src="/content/images/chrome/rebrand/aa-flight-icon.png"></div><p><span class="aa-busy-text"></span></p><span class="aa-busy-spinner" aria-hidden="true"></span></div></div>';
         var self = {},
             defaults = {
                 message: '',
                 showlogo: true,
                 position: undefined,
                 form: ''
             };
         self.settings = $.extend({}, defaults, options);
         self.source = this;
         self.start = function() {
             var urlPath = "/i18n/fragments/bookingPath/f_revenueWaitContent.jsp";

             if (fragmentJsp != undefined && fragmentJsp.length > 0) {
                 urlPath = "/i18n/fragments/bookingPath/" + fragmentJsp;
             }

             $.ajax({
                     type: "GET",
                     url: urlPath,
                     success: function (result) {
                         if (result) {
                             buildHtmlWithAdContent = result;
                         }
                     },
                     async: false
                 });

             var message,
                 $this = $(self.source).filter(':first'),
                 $module = $this.find('> .aa-busy-module'),
                 $form = $(self.settings.form),
                 condition = ($this.length > 0 && $module.length === 0),
                 $obj;
                 if (typeof $device !== "undefined" && $device.mobileApp){
                     $obj = $('<div class="aa-busy-module"><div class="aa-busy-bg"></div><div class="aa-busy-img"><div><img alt="American Airlines" src="/content/images/chrome/rebrand/icon_aa_spinner.png"></div><p><span class="aa-busy-text"></span></p><span class="aa-busy-spinner-app" aria-hidden="true"></span></div></div>');
                 }else{
                       $obj = $(buildHtmlWithAdContent);
                 }
             if(condition) {
                 $this.addClass('aa-busy');
                 $this.addClass('is-busy');
                 //set message
                 message = $this.attr('data-busy-message') || self.settings.message;
                 if(message !== '') {
                     $obj.find('.aa-busy-text').text(message);
                 }else{
                     $obj.find('.aa-busy-text').remove();
                 }
                 //set logo
                 if(!self.settings.showlogo) {
                     $obj.find('.aa-busy-logo').remove();
                 }
                 //add module
                 $this.append($obj);
                 $this.find('.screen-reader-text').attr('tabindex', -1).focus();
                 //delay form submit: helps preloading images and on safari
                 if($form.length > 0) {
                     setTimeout(function() {
                         $form.submit();
                     }, 500);
                     $(window).unload(function() {}); //disables bfcache for safari
                 }
             }
             return condition;
         };
         self.stop = function() {
             var $this = $(self.source).filter(':first'),
                 $module = $this.find('> .aa-busy-module'),
                 condition = ($this.length > 0 && $module.length > 0);
             if(condition) {
                 $module.animate({opacity: 'hide'}, 500, function() {
                     $module.remove();
                     $this.removeClass('aa-busy');
                     $this.removeClass('is-busy');
                     if($('*:focus').length === 0 && $this.hasClass('ui-dialog')) {
                         $this.find('h2').focus();
                     }
                 });
             }
             return condition;
         };
         return self;
     };
})(jQuery);
